import { render, staticRenderFns } from "./CardAdminCommentAction.vue?vue&type=template&id=b17c852c"
import script from "./CardAdminCommentAction.vue?vue&type=script&lang=js"
export * from "./CardAdminCommentAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports